import { useEffect, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Ticker from "./components/Ticker";
import LatestSection from "./components/LatestSection";
import TimelineSection from "./components/TimelineSection";
import HotRank from "./components/HotRank";
import FeatureSection from "./components/FeatureSection";
import AboutSection from "./components/AboutSection";
import FaqSection from "./components/FaqSection";
import NewsletterSection from "./components/NewsletterSection";
import Footer from "./components/Footer";

function ScrollTopButton() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="回到顶部"
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg shadow-primary-500/20 transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-lg" />
    </button>
  );
}

export default function Home() {
  return (
    <div id="top" className="relative min-h-screen w-full overflow-x-hidden bg-background-50 text-foreground-900">
      <Header />
      <main>
        <Hero />
        <Ticker />
        <LatestSection />
        <TimelineSection />
        <HotRank />
        <FeatureSection />
        <AboutSection />
        <FaqSection />
        <NewsletterSection />
      </main>
      <Footer />
      <ScrollTopButton />
    </div>
  );
}